<style scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}
</style>

<template>
<div>
    <Modal
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose">

        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">

            <FormItem label="上传EXCEL：" prop="file" >
                <FileUpload ref="upExcel" :action="actionUrlThumb" :hasUpload="hasUpload" :num="num" @setThumbUrl="setThumbUrlthumb"></FileUpload>
                <span class="simple-size">大小：3MB</span>
            </FormItem>

            <FormItem>
                <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
            </FormItem>
        </Form>

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import FileUpload from "../common/uploadFile";
    export default {
        props: {
            showModel: Boolean,
            fn:Function,
        },
        name: "Model3",
        data() {
            return {
                actionUrlThumb: this.config.urlArray.upExcel, //上传文件接口
                num: 1, //图片上传数量
                hasUpload: [], //已上传图片
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                formData: {//表单数据
                    excelPath: '',
                },
                ruleCustom: {//验证
                    excelPath: [
                        {required: true, message: '文件不能为空', trigger: 'blur' },
                    ],
                },
            }
        },
        components: {
            FileUpload
        },
        watch:{
            showModel(val){
                if(val){
                    // this.getData()
                }
            }
        },
        created(){

        },
        methods: {
            setThumbUrlthumb(url) { //获取图片上传后的路径   商品封面图
                this.formData.excelPath = url;
            },
            openOrClose(value) {
                if(value === true) {
                    this.title = '导入员工'
                } else { //关闭弹框后要做的处理
                    this.$refs.upExcel.clearImg();
                    this.resetForm();//重置表单
                }
            },
            subData(name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;

                        this.axios.post(this.config.urlArray.importEmp, this.formData).then((result) => {
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{this.disabled = false; })

                        }).catch((err) => {
                            common.msg('error','提交失败',()=>{this.disabled = false;})
                        });

                    }
                })
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.$refs.upExcel.clearImg();
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
                this.formData.excelPath = ''

            }
        }
    }
</script>
